import React from "react";
import { Box, Stack, TextField } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

// Theme config
const darkTheme = {
  green: "#12C895",
  greenLow: "rgba(18, 200, 149, 0.05)",
  glassBg: "rgba(20, 26, 36, 0.6)",
  borderRaw: "rgba(255, 255, 255, 0.06)",
  textWhite: "#F8FAFC",
  textMuted: "#94A3B8",
};

export default function BlogSearchBar({ onSearch, search }) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        mb: { xs: 5, md: 7 },
        mt: 3,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 700,
          height: { xs: 58, md: 64 },
          display: "flex",
          alignItems: "center",
          bgcolor: darkTheme?.glassBg,
          backdropFilter: "blur(24px)",
          border: `1px solid ${darkTheme?.borderRaw}`,
          borderRadius: "12px",
          transition: ".4s ease",
          overflow: "hidden",
          "&:hover": {
            borderColor: darkTheme?.green,
            boxShadow: `inset 0 0 20px ${darkTheme?.greenLow}`,
          },
          "&:focus-within": {
            borderColor: darkTheme?.green,
            boxShadow: `0 0 25px ${darkTheme?.greenLow}, inset 0 0 20px ${darkTheme?.greenLow}`,
          },
        }}
      >
        <TextField
          fullWidth
          value={search}
          onChange={(e) => onSearch(e?.target?.value?.trim())}
          variant="standard"
          placeholder="دنبال چه مقاله‌ای می‌گردید؟"
          InputProps={{ disableUnderline: true }}
          sx={{
            px: 3,
            "& input": {
              textAlign: "right",
              color: darkTheme?.textWhite,
              fontSize: "1rem",
            },
            "& input::placeholder": {
              color: darkTheme?.textMuted,
              opacity: 1,
            },
          }}
        />
        <Stack
          sx={{
            width: { xs: 60, md: 72 },
            height: "100%",
            color: darkTheme?.textMuted,
            transition: ".3s",
            justifyContent: "center",
            alignItems: "center",
            borderRight: `1px solid ${darkTheme?.borderRaw}`,
            "&:hover": {
              color: darkTheme?.green,
            },
          }}
        >
          <SearchRoundedIcon sx={{ fontSize: 26 }} />
        </Stack>
      </Box>
    </Box>
  );
}
